import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  Button,
  Popover,
  Typography,
  FormControl,
  Select,
  MenuItem,
  Checkbox,
  ListItemText,
} from "@mui/material";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { saveAs } from "file-saver";
import jsPDF from "jspdf";
import { useSelector } from "react-redux";
import * as XLSX from "xlsx";
import eOpsLogo from "../../../images/eops.png";
import excel from "../../../images/excel.png";
import mepcoLogo from "../../../images/mepcoLogo.png";
import pdf from "../../../images/pdf.png";
import print from "../../../images/print.png";
import { cfpBaseUrl } from "../../../network/urls";
import {
  convertDate,
  convertDatewithTime,
  printStamp,
  subdivisionName,
  getName,
  getShortMonthName,
  companyShortName,
  getCompanyName,
  companyName,
  getLogo,
} from "../../../services/Functions";
import { internalIconStyles } from "../../../style/common";
import "../../../style/common.scss";
import { Code } from "lucide-react";

const ComplaintSourceWise = () => {
  const getCurrentDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };
  const {
    token,
    code,
    name,
    roleName,
    roleTypeName,
    cscID,
    cfcLevelId,
    roleId,
    hierarchy: userHierarchy,
  } = useSelector((state) => state.auth);
  const offCode =
    userHierarchy == 1
      ? code
      : userHierarchy == 2
      ? code.slice(0, 2)
      : userHierarchy == 3
      ? code.slice(0, 3)
      : userHierarchy == 4
      ? code.slice(0, 4)
      : userHierarchy == 5
      ? code.slice(0, 5)
      : code;
  const [isLoading, setIsLoading] = React.useState(false);
  // const { officeCode: offCode } = useSelector(state => state.officeCode);
  const [viewBackdrop, setViewBackdrop] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [subDivisions, setSubDivisions] = useState(
    JSON.parse(window.localStorage.getItem("subDivisions")) || []
  );
  const [selectedCompanyCode, setSelectedCompanyCode] = useState("");
  const [totals, setTotals] = useState({});
  const [dateFrom, setDateFrom] = useState(getCurrentDate());
  const [dateTo, setDateTo] = useState(getCurrentDate());
  const tableRef = useRef(null);
  const [dateFromDisplay, setDateFromDisplay] = useState("");
  const [dateToDisplay, setDateToDisplay] = useState("");
  const [category, setCategory] = useState("");
  const [selectedDivision, setSelectedDivision] = useState("");
  const [selectedSubDivision, setSelectedSubDivision] = useState("");
  const [filteredDivisions, setFilteredDivisions] = useState([]);
  const [filteredSubDivisions, setFilteredSubDivisions] = useState([]);
  const [apiData, setApiData] = useState([]);
  const [circleCode, setCircleCode] = useState("");
  const [circleName, setCircleName] = useState("");
  const [officeCode, setOfficeCode] = useState("");
  const [officeName, setOfficeName] = useState("");
  const [hierarchy, setHierarchy] = useState("");
  const [filteredCircles, setFilteredCircles] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedRemarks, setSelectedRemarks] = useState("");
  const [selectedPerson, setSelectedPerson] = useState("");
  const [lastModifiedByOptions, setLastModifiedByOptions] = useState([]);
  const [selectedPerson1, setSelectedPerson1] = useState("");
  const [registeredByOptions, setRegisteredByOptions] = useState([]);
  const [desginationCodeToApi, setDesginationCodeToApi] = useState("1135");
  const [desginationList, setDesginationList] = useState([]);
  const [companyCode, setCompanyCode] = useState("15");
  const [complaintList, setComplaintList] = useState([]);
  const [selectedComplaint, setSelectedComplaint] = useState([]);
  const [selectedSource, setSelectedSource] = useState([]);
  const [isGoDisabled, setIsGoDisabled] = useState(true);
  const [lastAppliedFilters, setLastAppliedFilters] = useState(null);
  const [selectedComplaintForApi, setSelectedComplaintForApi] = useState("1");
  const [selectedSourceForApi, setSelectedSourceForApi] = useState("All");
  const [selectAllSource, setSelectAllSource] = useState(false);
  const [selectAllComplaint, setSelectAllComplaint] = useState(false);
  const [sourceError, setSourceError] = useState("");
  const [catagoryError, setCatagoryError] = useState("");
  useEffect(() => {
    // Reset all states to initial values
    setSelectedCompanyCode("");
    setCircleCode("");
    setSelectedDivision("");
    setSelectedSubDivision("");
    setFilteredCircles([]);
    setFilteredDivisions([]);
    setFilteredSubDivisions([]);
    setOfficeCode(offCode); // or '' if you want full reset
    setOfficeName("");
    setDateFrom(getCurrentDate());
    setDateTo(getCurrentDate());
    setSelectedComplaint([]);
    setSelectedComplaintForApi("1");
    setSelectAllComplaint(false);
    setSelectedSource([]);
    setSelectedSourceForApi("1");
    setSelectAllSource(false);
    setTableData([]);
    setTotals({});
    setApiData([]);
    setViewBackdrop(false);

    // Optionally refetch initial data if needed
    // getComplaints();
    // getStats(offCode, "1135");
  }, []); // Empty dependency → runs only on first render

  // const allSourceIds = complaintList.map(c => c.Id);
  const allComplaintIds = complaintList.map((c) => c.Id);

  const handleChangeCategory = (event) => {
    const value = event.target.value;
    const isAllSelected = value.includes("all");

    if (isAllSelected) {
      if (!selectAllComplaint) {
        setSelectedComplaint(allComplaintIds);
        setSelectedComplaintForApi(allComplaintIds.join(","));
        setSelectAllComplaint(true);
      } else {
        setSelectedComplaint([]);
        setSelectedComplaintForApi("");
        setSelectAllComplaint(false);
      }
    } else {
      setSelectedComplaint(value);
      setSelectedComplaintForApi(value.join(","));
      setSelectAllComplaint(false);

      if (
        value.length === allComplaintIds.length &&
        value.every((v) => allComplaintIds.includes(v))
      ) {
        setSelectAllComplaint(true);
      }
    }

    setCatagoryError("");
  };

  const handleSource = (event) => {
    const value = event.target.value;
    const isAllSelected = value.includes("all");

    if (isAllSelected) {
      if (!selectAllSource) {
        const allSourceValues = sourceList;
        setSelectedSource(allSourceValues);
        setSelectedSourceForApi(allSourceValues.join(","));
        setSelectAllSource(true);
      } else {
        setSelectedSource([]);
        setSelectedSourceForApi("");
        setSelectAllSource(false);
      }
    } else {
      setSelectedSource(value);
      setSelectedSourceForApi(value.join(","));
      setSelectAllSource(false);

      if (
        value.length === sourceList.length &&
        value.every((v) => sourceList.includes(v))
      ) {
        setSelectAllSource(true);
      }
    }

    setSourceError("");
  };

  const getCompanies = (code) => {
    switch (code) {
      case "10":
        return "Power Information Technology Company";
      case "11":
        return "Lahore Electric Supply Company";
      case "12":
        return "Gujranwala Electric Power Company";
      case "13":
        return "Faisalabad Electric Supply Company";
      case "14":
        return "Islamabad Electric Supply Company";
      case "15":
        return "Multan Electric Power Company";
      case "26":
        return "Peshawar Electric Supply Company";
      case "27":
        return "Hazara Electric Supply Company";
      case "38":
        return "Sukkur Electric Power Company";
      case "37":
        return "Hyderabad Electric Supply Company";
      case "48":
        return "Quetta Electric Supply Company";
      case "59":
        return "Tribal Electric Supply Company";
    }
  };
  useEffect(() => {
    setOfficeCode(circleCode);
  }, [circleCode]);

  // Fetch subDivisions for code == 10
  useEffect(() => {
    if (code == 10 && selectedCompanyCode) {
      const fetchSubDivisions = async () => {
        setViewBackdrop(true);
        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);
        const formdata = new FormData();
        formdata.append("companyCode", selectedCompanyCode);
        const requestOptions = {
          method: "POST",
          headers: myHeaders,
          body: formdata,
          redirect: "follow",
        };
        try {
          const response = await fetch(
            cfpBaseUrl + "customerFaciliationPortal/subDivWithCompDetails",
            requestOptions
          );
          if (response.ok) {
            const result = await response.json();
            if (result.status === "200") {
              setSubDivisions(result.message);
              setApiData(result.message);
              // Populate circles
              const circles = result.message.reduce((acc, curr) => {
                if (!acc.some((item) => item.circleCode === curr.circleCode)) {
                  acc.push({
                    circleCode: curr.circleCode,
                    circleName: curr.circleName,
                    companyCode: curr.companyCode,
                  });
                }
                return acc;
              }, []);
              setFilteredCircles(circles);
            } else {
              console.error("Error fetching subDivisions:", result.message);
              setSubDivisions([]);
              setFilteredCircles([]);
            }
          } else {
            throw new Error(`Request failed with status ${response.status}`);
          }
        } catch (error) {
          console.error("Error fetching subDivisions:", error);
          setSubDivisions([]);
          setFilteredCircles([]);
        } finally {
          setViewBackdrop(false);
        }
      };
      fetchSubDivisions();
    } else if (code != 10) {
      // For code != 10, populate circles from localStorage subDivisions
      const circles = subDivisions.reduce((acc, curr) => {
        if (!acc.some((item) => item.circleCode === curr.circleCode)) {
          acc.push({
            circleCode: curr.circleCode,
            circleName: curr.circleName,
            companyCode: curr.companyCode,
          });
        }
        return acc;
      }, []);
      setFilteredCircles(circles);
    }
  }, [code, selectedCompanyCode, token, cfpBaseUrl]);

  const handleChangeCompany = async (e) => {
    const selectedCompany = e.target.value;
    setSelectedCompanyCode(selectedCompany);
    setOfficeCode(selectedCompany);
    setOfficeName(getCompanies(selectedCompany) || "");

    if (code == 10 && selectedCompany) {
      setViewBackdrop(true);
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      const formdata = new FormData();
      formdata.append("companyCode", selectedCompany);
      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: formdata,
        redirect: "follow",
      };

      try {
        const response = await fetch(
          cfpBaseUrl + "customerFaciliationPortal/subDivWithCompDetails",
          requestOptions
        );
        if (response.ok) {
          const result = await response.json();
          if (result.status === "200") {
            setSubDivisions(result.message);
            setApiData(result.message);

            // Reset dropdowns
            setCircleCode("");
            setSelectedDivision("");
            setSelectedSubDivision("");
            setCircleName("");
            setFilteredDivisions([]);
            setFilteredSubDivisions([]);

            // Populate circles
            const circles = result.message.reduce((acc, curr) => {
              if (!acc.some((item) => item.circleCode === curr.circleCode)) {
                acc.push({
                  circleCode: curr.circleCode,
                  circleName: curr.circleName,
                  companyCode: curr.companyCode,
                });
              }
              return acc;
            }, []);
            setFilteredCircles(circles);
          } else {
            console.error("Error fetching subDivisions:", result.message);
            setSubDivisions([]);
            setFilteredCircles([]);
          }
        } else {
          throw new Error(`Request failed with status ${response.status}`);
        }
      } catch (error) {
        console.error("Error fetching subDivisions:", error);
        setSubDivisions([]);
        setFilteredCircles([]);
      } finally {
        setViewBackdrop(false);
      }
    } else if (!selectedCompany) {
      // Reset when no company is selected
      setOfficeName("PITC");
      setCircleCode("");
      setSelectedDivision("");
      setSelectedSubDivision("");
      setCircleName("");
      setFilteredDivisions([]);
      setFilteredSubDivisions([]);
      setFilteredCircles([]);
      setSubDivisions([]);
      setApiData([]);
    }
  };

  const handleCircleChange = async (event) => {
    const selectedCircleCode = event.target.value
      ? parseInt(event.target.value)
      : "";
    if (code == 10 && selectedCircleCode && selectedCompanyCode) {
      setViewBackdrop(true);
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      const formdata = new FormData();
      formdata.append("companyCode", selectedCompanyCode);
      formdata.append("circleCode", selectedCircleCode);
      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: formdata,
        redirect: "follow",
      };

      try {
        const response = await fetch(
          cfpBaseUrl + "customerFaciliationPortal/subDivWithCompDetails",
          requestOptions
        );
        if (response.ok) {
          const result = await response.json();
          if (result.status === "200") {
            setSubDivisions(result.message);
            setApiData(result.message);

            setCircleCode(selectedCircleCode);
            setOfficeCode(selectedCircleCode);
            const circle = filteredCircles.find(
              (circle) => circle.circleCode === selectedCircleCode
            );
            const circleName = circle?.circleName || "";
            setOfficeName(circleName.concat(" Circle"));
            setCircleName(circleName);
            setSelectedDivision("");
            setSelectedSubDivision("");
            setFilteredSubDivisions([]);

            // Populate divisions
            const uniqueDivisions = result.message
              .filter((item) => item.circleCode === selectedCircleCode)
              .reduce((acc, item) => {
                if (
                  !acc.some(
                    (division) => division.divisionCode === item.divisionCode
                  )
                ) {
                  acc.push({
                    divisionCode: item.divisionCode,
                    divisionName: item.divisionName,
                    companyCode: item.companyCode,
                  });
                }
                return acc;
              }, []);
            setFilteredDivisions(uniqueDivisions);
          } else {
            console.error("Error fetching subDivisions:", result.message);
            setSubDivisions([]);
            setFilteredDivisions([]);
          }
        } else {
          throw new Error(`Request failed with status ${response.status}`);
        }
      } catch (error) {
        console.error("Error fetching subDivisions:", error);
        setSubDivisions([]);
        setFilteredDivisions([]);
      } finally {
        setViewBackdrop(false);
      }
    } else if (code == 10 && !selectedCircleCode && selectedCompanyCode) {
      setViewBackdrop(true);
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      const formdata = new FormData();
      formdata.append("companyCode", selectedCompanyCode);
      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: formdata,
        redirect: "follow",
      };

      try {
        const response = await fetch(
          cfpBaseUrl + "customerFaciliationPortal/subDivWithCompDetails",
          requestOptions
        );
        if (response.ok) {
          const result = await response.json();
          if (result.status === "200") {
            setSubDivisions(result.message);
            setApiData(result.message);

            setCircleCode("");
            setOfficeCode(selectedCompanyCode);
            setOfficeName(getCompanies(selectedCompanyCode));
            setCircleName("");
            setSelectedDivision("");
            setSelectedSubDivision("");
            setFilteredSubDivisions([]);

            // Populate divisions
            const uniqueDivisions = result.message.reduce((acc, item) => {
              if (
                !acc.some(
                  (division) => division.divisionCode === item.divisionCode
                )
              ) {
                acc.push({
                  divisionCode: item.divisionCode,
                  divisionName: item.divisionName,
                  companyCode: item.companyCode,
                });
              }
              return acc;
            }, []);
            setFilteredDivisions(uniqueDivisions);
          } else {
            console.error("Error fetching subDivisions:", result.message);
            setSubDivisions([]);
            setFilteredDivisions([]);
          }
        } else {
          throw new Error(`Request failed with status ${response.status}`);
        }
      } catch (error) {
        console.error("Error fetching subDivisions:", error);
        setSubDivisions([]);
        setFilteredDivisions([]);
      } finally {
        setViewBackdrop(false);
      }
    } else if (selectedCircleCode) {
      setCircleCode(selectedCircleCode);
      setOfficeCode(selectedCircleCode);
      const circle = filteredCircles.find(
        (circle) => circle.circleCode === selectedCircleCode
      );
      const circleName = circle?.circleName || "";
      setOfficeName(circleName.concat(" Circle"));
      setCircleName(circleName);
      setSelectedDivision("");
      setSelectedSubDivision("");
      setFilteredSubDivisions([]);
      const uniqueDivisions = subDivisions
        .filter((item) => item.circleCode === selectedCircleCode)
        .reduce((acc, item) => {
          if (
            !acc.some((division) => division.divisionCode === item.divisionCode)
          ) {
            acc.push({
              divisionCode: item.divisionCode,
              divisionName: item.divisionName,
              companyCode: item.companyCode,
            });
          }
          return acc;
        }, []);
      setFilteredDivisions(uniqueDivisions);
    } else {
      // Handle "All Circle" for code != 10
      setCircleCode("");
      setSelectedDivision("");
      setSelectedSubDivision("");
      setFilteredSubDivisions([]);
      if (roleTypeName == "Technical") {
        if (offCode) {
          setOfficeCode(offCode == 10 ? 15 : offCode);
          let officeName = getName(
            offCode == 10 ? "15" : offCode.toString(),
            subDivisions
          );
          setOfficeName(officeName.concat(" Region"));
          setCircleName("");
          const circles = subDivisions.reduce((acc, curr) => {
            if (!acc.some((item) => item.circleCode === curr.circleCode)) {
              acc.push({
                circleCode: curr.circleCode,
                circleName: curr.circleName,
                companyCode: curr.companyCode,
              });
            }
            return acc;
          }, []);
          setFilteredCircles(circles);
          const uniqueDivisions = subDivisions.reduce((acc, item) => {
            if (
              !acc.some(
                (division) => division.divisionCode === item.divisionCode
              )
            ) {
              acc.push({
                divisionCode: item.divisionCode,
                divisionName: item.divisionName,
                companyCode: item.companyCode,
              });
            }
            return acc;
          }, []);
          setFilteredDivisions(uniqueDivisions);
        }
      } else if (roleTypeName == "Commercial") {
        if (cfcLevelId == 2) {
          if (offCode) {
            setOfficeCode(offCode.toString().slice(0, 2));
            let offName = cscID;
            setOfficeName(offName);
            setHierarchy(cfcLevelId);
            const uniqueDivisions = subDivisions.reduce((acc, item) => {
              if (
                !acc.some(
                  (division) => division.divisionCode === item.divisionCode
                )
              ) {
                acc.push({
                  divisionCode: item.divisionCode,
                  divisionName: item.divisionName,
                  companyCode: item.companyCode,
                });
              }
              return acc;
            }, []);
            setFilteredDivisions(uniqueDivisions);
          }
        } else if (cfcLevelId == 3) {
          if (offCode) {
            setOfficeCode(offCode.toString().slice(0, 3));
            let offName = cscID;
            setOfficeName(offName);
            setHierarchy(cfcLevelId);
            const uniqueDivisions = subDivisions.reduce((acc, item) => {
              if (
                !acc.some(
                  (division) => division.divisionCode === item.divisionCode
                )
              ) {
                acc.push({
                  divisionCode: item.divisionCode,
                  divisionName: item.divisionName,
                  companyCode: item.companyCode,
                });
              }
              return acc;
            }, []);
            setFilteredDivisions(uniqueDivisions);
          }
        }
      }
    }
  };

  const handleDivisionChange = async (e) => {
    const selectedDivisionCode = parseInt(e.target.value);
    if (code == 10 && selectedDivisionCode && selectedCompanyCode) {
      setViewBackdrop(true);
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      const formdata = new FormData();
      formdata.append("companyCode", selectedCompanyCode);
      formdata.append("divisionCode", selectedDivisionCode);
      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: formdata,
        redirect: "follow",
      };

      try {
        const response = await fetch(
          cfpBaseUrl + "customerFaciliationPortal/subDivWithCompDetails",
          requestOptions
        );
        if (response.ok) {
          const result = await response.json();
          if (result.status === "200") {
            setSubDivisions(result.message);
            setApiData(result.message);

            setSelectedDivision(selectedDivisionCode);
            setOfficeCode(selectedDivisionCode);
            const division = filteredDivisions.find(
              (division) => division.divisionCode === selectedDivisionCode
            );
            const divisionName = division?.divisionName || "";
            setOfficeName(divisionName.concat(" Division"));
            setSelectedSubDivision("");
            const uniqueSubDivisions = result.message
              .filter((item) => item.divisionCode == selectedDivisionCode)
              .reduce((acc, item) => {
                if (
                  !acc.some(
                    (sub) => sub.subDivisionCode === item.subDivisionCode
                  )
                ) {
                  acc.push({
                    subDivisionCode: item.subDivisionCode,
                    subDivisionName: item.subDivisionName,
                    companyCode: item.companyCode,
                  });
                }
                return acc;
              }, []);
            setFilteredSubDivisions(uniqueSubDivisions);
          } else {
            console.error("Error fetching subDivisions:", result.message);
            setSubDivisions([]);
            setFilteredSubDivisions([]);
          }
        } else {
          throw new Error(`Request failed with status ${response.status}`);
        }
      } catch (error) {
        console.error("Error fetching subDivisions:", error);
        setSubDivisions([]);
        setFilteredSubDivisions([]);
      } finally {
        setViewBackdrop(false);
      }
    } else if (selectedDivisionCode) {
      setSelectedDivision(selectedDivisionCode);
      setOfficeCode(selectedDivisionCode);
      const divisionName =
        filteredDivisions.find(
          (division) => division.divisionCode === selectedDivisionCode
        )?.divisionName || "";
      setOfficeName(divisionName.concat(" Division"));
      setSelectedSubDivision("");
      const uniqueSubDivisions = subDivisions
        .filter((item) => item.divisionCode == selectedDivisionCode)
        .reduce((acc, item) => {
          if (
            !acc.some((sub) => sub.subDivisionCode === item.subDivisionCode)
          ) {
            acc.push({
              subDivisionCode: item.subDivisionCode,
              subDivisionName: item.subDivisionName,
              companyCode: item.companyCode,
            });
          }
          return acc;
        }, []);
      setFilteredSubDivisions(uniqueSubDivisions);
    } else {
      setSelectedDivision("");
      setOfficeCode(circleCode ? circleCode : offCode);
      let officeName = getName(
        circleCode ? circleCode.toString() : offCode.toString(),
        subDivisions
      );
      setOfficeName(officeName.concat(" Circle"));
      setSelectedSubDivision("");
      setFilteredSubDivisions([]);
      const uniqueDivisions = subDivisions
        .filter(
          (item) => item.circleCode == (circleCode ? circleCode : offCode)
        )
        .reduce((acc, item) => {
          if (
            !acc.some((division) => division.divisionCode === item.divisionCode)
          ) {
            acc.push({
              divisionCode: item.divisionCode,
              divisionName: item.divisionName,
              companyCode: item.companyCode,
            });
          }
          return acc;
        }, []);
      setFilteredDivisions(uniqueDivisions);
    }
  };

  const handleSubDivisionChange = async (e) => {
    const selectedSubDivisionCode = parseInt(e.target.value);
    if (code == 10 && selectedSubDivisionCode && selectedCompanyCode) {
      setViewBackdrop(true);
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      const formdata = new FormData();
      formdata.append("companyCode", selectedCompanyCode);
      formdata.append("subDivisionCode", selectedSubDivisionCode);
      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: formdata,
        redirect: "follow",
      };

      try {
        const response = await fetch(
          cfpBaseUrl + "customerFaciliationPortal/subDivWithCompDetails",
          requestOptions
        );
        if (response.ok) {
          const result = await response.json();
          if (result.status === "200") {
            setSubDivisions(result.message);
            setApiData(result.message);

            setSelectedSubDivision(selectedSubDivisionCode);
            setOfficeCode(selectedSubDivisionCode);
            const subDivision = filteredSubDivisions.find(
              (sub) => sub.subDivisionCode === selectedSubDivisionCode
            );
            const subDivisionName = subDivision?.subDivisionName || "";
            setOfficeName(subDivisionName.concat(" Sub Division"));
          } else {
            console.error("Error fetching subDivisions:", result.message);
            setSubDivisions([]);
          }
        } else {
          throw new Error(`Request failed with status ${response.status}`);
        }
      } catch (error) {
        console.error("Error fetching subDivisions:", error);
        setSubDivisions([]);
      } finally {
        setViewBackdrop(false);
      }
    } else if (selectedSubDivisionCode) {
      setSelectedSubDivision(selectedSubDivisionCode);
      setOfficeCode(selectedSubDivisionCode);
      const subDivisionName =
        filteredSubDivisions.find(
          (sub) => sub.subDivisionCode === selectedSubDivisionCode
        )?.subDivisionName || "";
      setOfficeName(subDivisionName.concat(" Sub Division"));
    } else {
      setSelectedSubDivision("");
      let officeName = getName(
        selectedDivision ? selectedDivision.toString() : offCode.toString(),
        subDivisions
      );
      setOfficeName(officeName.concat(" Division"));
      setOfficeCode(selectedDivision ? selectedDivision : offCode);
    }
  };

  useEffect(() => {
    if (roleTypeName == "Technical") {
      if (offCode) {
        setOfficeCode(offCode == 10 ? 15 : offCode);
        let offName = getName(
          offCode == 10 ? "15" : offCode.toString(),
          subDivisions
        );
        setOfficeName(offName);
        setHierarchy(offCode.toString().length);
      }
    } else if (roleTypeName == "Commercial") {
      if (cfcLevelId == 1) {
        if (offCode) {
          if (offCode == 10) {
            setOfficeCode(15);
            setOfficeName("PITC");
          } else {
            setOfficeCode(offCode);
            let offName = getName(offCode, subDivisions);
            setOfficeName(offName);
          }

          setHierarchy(offCode.length);
        }
      } else if (cfcLevelId == 2) {
        if (offCode) {
          setOfficeCode(offCode.toString().slice(0, 2));
          let offName = cscID;
          setOfficeName(offName);
          setHierarchy(cfcLevelId);
        }
      } else if (cfcLevelId == 3) {
        if (offCode) {
          setOfficeCode(offCode.toString().slice(0, 3));
          let offName = cscID;
          setOfficeName(offName);
          setHierarchy(cfcLevelId);
        }
      } else if (cfcLevelId == 4 || cfcLevelId == 5) {
        if (offCode) {
          setOfficeCode(offCode.toString().slice(0, 4));
          let offName = cscID;
          setOfficeName(offName);
          setHierarchy(cfcLevelId);
        }
      }
    }
  }, [offCode, cfcLevelId, roleTypeName, cscID]);

  useEffect(() => {
    if (hierarchy) {
      if (hierarchy == 1 || cfcLevelId === 1) {
        console.log("1 wala if");
        let circles = subDivisions.reduce((acc, curr) => {
          if (!acc.some((item) => item.circleCode === curr.circleCode)) {
            acc.push({
              circleCode: curr.circleCode,
              circleName: curr.circleName,
              companyCode: curr.companyCode,
            });
          }
          return acc;
        }, []);
        setFilteredCircles(circles);
      } else if (hierarchy == 2 || cfcLevelId == 2) {
        console.log("2 wala if");
        let circles = subDivisions.reduce((acc, curr) => {
          if (!acc.some((item) => item.circleCode === curr.circleCode)) {
            acc.push({
              circleCode: curr.circleCode,
              circleName: curr.circleName,
              companyCode: curr.companyCode,
            });
          }
          return acc;
        }, []);
        setFilteredCircles(circles);
      } else if (hierarchy == 3 || cfcLevelId == 3) {
        console.log("3 wala if");
        setCircleCode(offCode.slice(0, 3));
        console.log(offCode.slice(0, 3), "djlsahjdhalhdalhlkd");
        const uniqueDivisions = subDivisions
          .filter((item) => item.circleCode == offCode.slice(0, 3))
          .reduce((acc, item) => {
            if (
              !acc.some(
                (division) => division.divisionCode === item.divisionCode
              )
            ) {
              acc.push({
                divisionCode: item.divisionCode,
                divisionName: item.divisionName,
                companyCode: item.companyCode,
              });
            }
            return acc;
          }, []);
        setFilteredDivisions(uniqueDivisions);
      } else if (
        hierarchy == 4 ||
        cfcLevelId == 4 ||
        hierarchy == 5 ||
        cfcLevelId == 5
      ) {
        console.log("4 wala if");
        setSelectedDivision(offCode.slice(0, 4));
        const uniqueSubDivisions = subDivisions
          .filter((item) => item.divisionCode == offCode.slice(0, 4))
          .reduce((acc, item) => {
            if (
              !acc.some((sub) => sub.subDivisionCode === item.subDivisionCode)
            ) {
              acc.push({
                subDivisionCode: item.subDivisionCode,
                subDivisionName: item.subDivisionName,
                companyCode: item.companyCode,
              });
            }
            return acc;
          }, []);
        setFilteredSubDivisions(uniqueSubDivisions);
      }
    }
  }, [hierarchy, cfcLevelId, subDivisions]);

  const getStats = async (
    officeCode,
    selectedComplaintForApi,
    selectedSourceForApi,
    dateFrom,
    dateTo
  ) => {
    setViewBackdrop(true);
    const myHeaders = new Headers();
    myHeaders.append("Authorization", token);
    myHeaders.append("Content-Type", "application/json");

    const raw = JSON.stringify({
      officeCode: officeCode,
      complaintSource: selectedSourceForApi,
      complaintTypeId: selectedComplaintForApi,
      dateFrom: dateFrom,
      dateTo: dateTo,
    });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(
      "https://eopsapi.pitc.com.pk//lineComplaints/getAllComplaintsBySourceAndType",
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        if (result.status == "200") {
          const data = result.data;
          setViewBackdrop(false);

          setTableData(data);
        } else if (result.status == "400") {
          setViewBackdrop(false);

          setTableData([]);
        }
      })
      .catch((error) => console.error(error));

    // console.log(officeCode, 'office Code');
    // setViewBackdrop(true);
    // try {
    //     const myHeaders = new Headers();
    //     myHeaders.append("Authorization", token);
    //     myHeaders.append("Content-Type", "application/json");

    //     const raw = JSON.stringify({
    //         "officecode": selectedSubDivision ? selectedSubDivision : selectedDivision ? selectedDivision : officeCode ? officeCode : code.slice(0, 2),
    //         "roleId": roleId
    //     });

    //     const requestOptions = {
    //         method: "POST",
    //         headers: myHeaders,
    //         body: raw,
    //         redirect: "follow"
    //     };

    //     const response = await fetch(cfpBaseUrl + "reports/geteOpsSubDivisionUserStatus", requestOptions);
    //     const result = await response.json();

    //     if (result.status == "200") {
    //         const data = result.data;

    //         setTableData(data);
    //     } else if (result.status == "400") {
    //         setTableData([]);
    //     }

    // } catch (error) {
    //     console.error("Error fetching stats:", error);
    //     setTableData([]);
    // }
    // setViewBackdrop(false);
  };

  const exportToExcel = () => {
    const dataForExcel = tableData.map((item) => ({
      "Office Code": item.officeCode,
      "Complaint Category":
        complaintList.find((c) => c.Id === item.complaintTypeId)?.Name ||
        item.complaintTypeId,
      "Total Count": item.totalCount,
    }));

    // Add Total Row
    const totalCount = tableData.reduce(
      (sum, item) => sum + (item.totalCount || 0),
      0
    );
    dataForExcel.push({
      "Office Code": "Total",
      "Complaint Category": "-",
      "Total Count": totalCount,
    });

    const ws = XLSX.utils.json_to_sheet(dataForExcel);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Complaint Report");

    // Auto-size columns
    const colWidths = [
      { wch: 15 }, // Office Code
      { wch: 30 }, // Complaint Category
      { wch: 15 }, // Total Count
    ];
    ws["!cols"] = colWidths;

    const filename = `${formatDate(dateFrom)}${
      dateFrom !== dateTo ? ` to ${formatDate(dateTo)}` : ""
    } - ${officeName} - Complaint-Source-Wise.xlsx`;
    XLSX.writeFile(wb, filename);
  };

  const connectionTypes = ["Office Code", "Complaint Catagory", "Total Count"];

  function getCurrentDateFormatted(date) {
    const day = String(date.getDate()).padStart(2, "0");
    const options = { month: "short" };
    const month = date.toLocaleString("en-US", options);
    const year = String(date.getFullYear()).slice(-2);
    return `${day}-${month}-${year}`;
  }

  const DownloadPdf = async (print) => {
    return new Promise((resolve) => {
      let offName = officeName;
      let dateToPrint = getCurrentDateFormatted(new Date());

      // Table Data
      const headers = [
        { content: "Office Code", styles: { fontStyle: "bold" } },
        { content: "Complaint Category", styles: { fontStyle: "bold" } },
        { content: "Total Count", styles: { fontStyle: "bold" } },
      ];

      const body = tableData.map((item) => [
        item.officeCode,
        complaintList.find((c) => c.Id === item.complaintTypeId)?.Name ||
          item.complaintTypeId,
        item.totalCount.toString(),
      ]);

      // Total Row
      const total = tableData.reduce((sum, item) => sum + item.totalCount, 0);
      body.push([
        {
          content: "Total",
          styles: { fontStyle: "bold", fillColor: [255, 245, 192] },
        },
        {
          content: "-",
          styles: { fontStyle: "bold", fillColor: [255, 245, 192] },
        },
        {
          content: total.toString(),
          styles: { fontStyle: "bold", fillColor: [255, 245, 192] },
        },
      ]);

      // No data?
      if (tableData.length === 0) {
        body.push([
          {
            content: "No Data Found",
            colSpan: 3,
            styles: {
              halign: "center",
              textColor: [255, 0, 0],
              fontStyle: "bold",
            },
          },
        ]);
      }

      const pdf = new jsPDF("landscape", "mm", "a4", { compressPdf: true });
      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();
      const logoWidth =
        companyCode === "12" ||
        companyCode === "13" ||
        companyCode === "11" ||
        companyCode === "16" ||
        companyCode === "27" ||
        companyCode === "48" ||
        companyCode === "59"
          ? 25
          : 30;
      const logoHeight =
        companyCode === "12" ||
        companyCode === "13" ||
        companyCode === "11" ||
        companyCode === "16" ||
        companyCode === "27" ||
        companyCode === "48" ||
        companyCode === "59"
          ? 20
          : 10;
      pdf.addImage(getLogo(companyCode), "PNG", 15, 5, logoWidth, logoHeight);

      const eOpsLogoWidth = 20;
      const eOpsLogoHeight = 8;
      const eOpsLogoXPosition =
        companyCode === "12" ||
        companyCode === "13" ||
        companyCode === "11" ||
        companyCode === "16" ||
        companyCode === "27" ||
        companyCode === "48" ||
        companyCode === "59"
          ? 43
          : 17;
      pdf.addImage(
        eOpsLogo,
        "PNG",
        eOpsLogoXPosition,
        companyCode === "12" ||
          companyCode === "13" ||
          companyCode === "11" ||
          companyCode === "16" ||
          companyCode === "27" ||
          companyCode === "48" ||
          companyCode === "59"
          ? 12
          : 17,
        eOpsLogoWidth,
        eOpsLogoHeight
      );

      pdf.setFontSize(10);
      pdf.text(convertDatewithTime(new Date()), pageWidth - 65, 12);
      pdf.text("Name: " + name, pageWidth - 65, 17);
      pdf.text("Designation: " + roleName, pageWidth - 65, 22);

      pdf.setFontSize(12);
      pdf.text(getCompanies(companyCode), pageWidth / 2, 12, {
        align: "center",
      });
      pdf.text(
        `eOps Complaint Report Source and Status Wise`,
        pageWidth / 2,
        18,
        { align: "center" }
      );
      pdf.setFontSize(10);
      pdf.text(
        `eOps Complaint Report Source and Status Wise for ${offName} of ${dateToPrint}`,
        pageWidth / 2,
        25,
        { align: "center" }
      );

      pdf.autoTable({
        startY: 28,
        head: [headers],
        body: body,

        styles: {
          cellPadding: 1,
          fontSize: 8,
          halign: "center",
          lineWidth: 0.25,
          lineColor: "white",
          overflow: "linebreak",
        },

        margin: { top: 2 },
        theme: "striped",

        headStyles: {
          valign: "middle",
          fontStyle: "bold",
        },

        bodyStyles: {
          halign: "center",
        },

        tableWidth: "wrap",
        columnStyles: {
          0: { cellWidth: 40, halign: "left" },
          1: { cellWidth: 170, halign: "center" },
          2: { cellWidth: 60, halign: "center" },
        },

        didParseCell: (data) => {
          if (
            data.row.raw[0]?.content === "Total" ||
            data.row.raw[0] === "Total"
          ) {
            data.cell.styles.fontStyle = "bold";
          }
        },

        pageBreak: "auto",
        tableLineWidth: 0,
      });

      const totalPages = pdf.internal.getNumberOfPages();
      for (let i = 1; i <= totalPages; i++) {
        pdf.setPage(i);
        const pageNumberText = `Page ${i} of ${totalPages}`;
        pdf.setFontSize(10);
        pdf.text(pageNumberText, pageWidth - 45, pageHeight - 10);
      }

      if (print) {
        pdf.save(
          `${offName}-${dateToPrint}-Complaint-Report-Source-and-Status-Wise.pdf`
        );
      } else {
        resolve(pdf);
      }
    });
  };

  const printPDF = async () => {
    let pdf = await DownloadPdf(false);
    const pdfUrl = pdf.output("bloburl");

    const iframe = document.createElement("iframe");
    iframe.style.position = "absolute";
    iframe.style.top = "0";
    iframe.style.left = "0";
    iframe.style.width = "0";
    iframe.style.height = "0";
    iframe.src = pdfUrl;
    document.body.appendChild(iframe);

    const cancelButton = document.createElement("button");
    cancelButton.textContent = "Cancel";
    cancelButton.style.position = "fixed";
    cancelButton.style.top = "20px";
    cancelButton.style.right = "20px";
    cancelButton.style.padding = "10px 20px";
    cancelButton.style.backgroundColor = "#ff4d4d";
    cancelButton.style.color = "white";
    cancelButton.style.border = "none";
    cancelButton.style.borderRadius = "5px";
    cancelButton.style.cursor = "pointer";
    document.body.appendChild(cancelButton);

    iframe.onload = () => {
      iframe.contentWindow.focus();
      iframe.contentWindow.print();
    };

    cancelButton.addEventListener("click", () => {
      if (iframe.parentNode) {
        document.body.removeChild(iframe);
      }
      if (cancelButton.parentNode) {
        document.body.removeChild(cancelButton);
      }
    });
  };

  // useEffect(() => {
  //     // getStats(offCode, desginationCodeToApi);
  //     getStats(officeCode,selectedComplaintForApi,selectedSourceForApi,dateFrom,dateTo)
  // }, []);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const options = { day: "2-digit", month: "short", year: "numeric" };
    return date.toLocaleDateString("en-GB", options).replace(/ /g, "-");
  };

  useEffect(() => {
    const getDesgination = async () => {
      setViewBackdrop(true);
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      const raw = "";
      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };
      fetch(
        cfpBaseUrl + "workForce/getListOfSubDivisionDesignations",
        requestOptions
      )
        .then((response) => response.json())
        .then((result) => {
          setViewBackdrop(false);
          if (result.message == "Data Found.") {
            setDesginationList(result.data);
          }
        })
        .catch((error) => console.error(error));
    };
    getDesgination();
  }, [companyCode]);

  const getDateDifference = (startDate, endDate) => {
    const startDates = startDate.split(",")[0];
    const endDates = endDate.split(",")[0];
    const start = new Date(startDates);
    const end = new Date(endDates);
    const differenceInTime = end - start;
    const differenceInDays = differenceInTime / (1000 * 3600 * 24);
    return differenceInDays;
  };

  const handleRemarksClick = (event, remarks) => {
    if (remarks && remarks.trim() !== "") {
      setAnchorEl(event.currentTarget);
      setSelectedRemarks(remarks);
    }
  };

  const handleClosePopover = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const handleChangeDesgination = (e) => {
    console.log(e.target.value, "e.target.value");
    setDesginationCodeToApi(e.target.value);
  };

  const getComplaints = async () => {
    const myHeaders = new Headers();
    myHeaders.append("Authorization", token);

    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(
      "https://eopsapi.pitc.com.pk/lineComplaints/getAllComplaintTypes",
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => setComplaintList(result.data || []))
      .catch((error) => console.error(error));
  };

  useEffect(() => {
    getComplaints();
  }, []);

  const [sourceList, setSourceList] = useState([]); // from API
  // const [selectedSource, setSelectedSource] = useState([]);
  // const [selectedSourceForApi, setSelectedSourceForApi] = useState(""); // final comma string
  // const [selectAllSource, setSelectAllSource] = useState(false);

  useEffect(() => {
    const fetchSources = async () => {
      try {
        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);

        const response = await fetch(
          "https://eopsapi.pitc.com.pk/lineComplaints/getAllComplaintSources",
          { method: "GET", headers: myHeaders, redirect: "follow" }
        );
        const result = await response.json();

        if (result?.status === "200" && Array.isArray(result.data)) {
          const uniqueSources = Array.from(
            new Set(
              result.data.map((item) => item.source?.trim()).filter(Boolean)
            )
          );
          setSourceList(uniqueSources); // ← ["FESCOSMART", "SUNDAR SMART", ...]
        }
      } catch (error) {
        console.error("Error fetching sources:", error);
      }
    };
    fetchSources();
  }, [token]);

  const allSourceValues = sourceList.map((s) => s.Name);

  const currentFilters = {
    officeCode,
    selectedSource: selectedSourceForApi,
    selectedComplaint: selectedComplaintForApi,
    dateFrom,
    dateTo,
  };

  useEffect(() => {
    if (lastAppliedFilters === null) {
      setIsGoDisabled(false);
      return;
    }

    const hasChanged =
      JSON.stringify(currentFilters) !== JSON.stringify(lastAppliedFilters);
    setIsGoDisabled(!hasChanged);
  }, [
    officeCode,
    selectedSourceForApi,
    selectedComplaintForApi,
    dateFrom,
    dateTo,
  ]);

  const handleGoClick = () => {
    let hasError = false;

    if (selectedSource.length === 0) {
      setSourceError("Please select at least one Source.");
      hasError = true;
    } else {
      setSourceError("");
    }

    if (selectedComplaint.length === 0) {
      setCatagoryError("Please select at least one Complaint Category.");
      hasError = true;
    } else {
      setCatagoryError("");
    }

    if (hasError) {
      return;
    }

    getStats(
      officeCode,
      selectedComplaintForApi,
      selectedSourceForApi,
      dateFrom,
      dateTo
    );

    setLastAppliedFilters({ ...currentFilters });
    setIsGoDisabled(true);
  };

   const noDataAvailable = () => {
    alert("No data available to export or print.");
  };

  return (
    (
      <>
        <Box className="form-box">
          <div style={{ display: "flex", flexDirection: "row" }}>
            <Box className="application-table" style={{ marginRight: "10px" }}>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <div>
                  <h3 style={{ color: "#006ad1", marginBottom: "10px" }}>
                    eOps Complaint Report Source and Status Wise
                  </h3>
                </div>
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                   <div
                    onClick={() => {
                      if (tableData.length === 0) {
                        noDataAvailable();
                        return;
                      }
                      DownloadPdf(true);
                    }}
                    style={{ height: "40px", marginLeft: "15px" }}
                  >
                    <img
                      src={pdf}
                      alt="pdf"
                      style={{ ...internalIconStyles, height: "100%" }}
                    />
                  </div>

                  <div
                    onClick={() => {
                      if (tableData.length === 0) {
                        noDataAvailable();
                        return;
                      }
                      exportToExcel();
                    }}
                    style={{ height: "40px" }}
                  >
                    <img
                      src={excel}
                      alt="Excel"
                      style={{ ...internalIconStyles, height: "100%" }}
                    />
                  </div>

                  <div
                    onClick={() => {
                      if (tableData.length === 0) {
                        noDataAvailable();
                        return;
                      }
                      printPDF();
                    }}
                    style={{ height: "40px" }}
                  >
                    <img
                      src={print}
                      alt="print"
                      style={{ ...internalIconStyles, height: "100%" }}
                    />
                  </div>
                </div>
              </div>
              <div className="div-datagrid">
                <div className="reports-container">
                  <div
                    className="filter-fields"
                    style={{ gap: code === "10" ? "10px" : "15px" }}
                  >
                    <div className="field-container">
                      <Typography className="field-label">
                        {" "}
                        Date From
                      </Typography>
                      <input
                        type="date"
                        className="date-field"
                        value={dateFrom}
                        onChange={(e) => {
                          setDateFrom(e.target.value);
                        }}
                      />
                    </div>
                    <div className="field-container">
                      <Typography className="field-label"> Date To</Typography>
                      <input
                        type="date"
                        className="date-field"
                        value={dateTo}
                        max={new Date().toISOString().split("T")[0]}
                        onChange={(e) => {
                          setDateTo(e.target.value);
                        }}
                      />
                    </div>
                    {code == 10 && (
                      <div className="field-container">
                        <Typography className="field-label">Company</Typography>
                        <select
                          className="dropdown-field"
                          style={{ backgroundColor: "white" }}
                          value={selectedCompanyCode}
                          onChange={handleChangeCompany}
                        >
                          <option value="10">Select Company</option>
                          <option value="11">LESCO</option>
                          <option value="12">GEPCO</option>
                          <option value="13">FESCO</option>
                          <option value="14">IESCO</option>
                          <option value="15">MEPCO</option>
                          <option value="26">PESCO</option>
                          <option value="27">HAZECO</option>
                          <option value="37">HESCO</option>
                          <option value="38">SEPCO</option>
                          <option value="48">QESCO</option>
                          <option value="59">TESCO</option>
                        </select>
                      </div>
                    )}

                    {hierarchy <= 2 && (
                      <div className="field-container">
                        <Typography className="field-label">Circle</Typography>
                        <select
                          className="dropdown-field"
                          style={{ backgroundColor: "white" }}
                          value={circleCode || ""}
                          onChange={handleCircleChange}
                        >
                          <option value="">All Circle</option>
                          {filteredCircles.map((circle) => (
                            <option
                              key={circle.circleCode}
                              value={circle.circleCode}
                            >
                              {circle.circleName}
                            </option>
                          ))}
                        </select>
                      </div>
                    )}

                    {hierarchy <= 3 && (
                      <div className="field-container">
                        <Typography className="field-label">
                          Division
                        </Typography>
                        <select
                          className="dropdown-field"
                          style={{ backgroundColor: "white" }}
                          value={selectedDivision || ""}
                          onChange={handleDivisionChange}
                          disabled={!circleCode}
                        >
                          <option value="">All Division</option>
                          {filteredDivisions.map((division) => (
                            <option
                              key={division.divisionCode}
                              value={division.divisionCode}
                            >
                              {division.divisionName}
                            </option>
                          ))}
                        </select>
                      </div>
                    )}

                    {hierarchy <= 4 && (
                      <div className="field-container">
                        <Typography className="field-label">
                          Sub-Division
                        </Typography>
                        <select
                          className="dropdown-field"
                          style={{ backgroundColor: "white" }}
                          value={selectedSubDivision || ""}
                          onChange={handleSubDivisionChange}
                          disabled={!selectedDivision}
                        >
                          <option value="">All Sub-Division</option>
                          {filteredSubDivisions.map((subDivision) => (
                            <option
                              key={subDivision.subDivisionCode}
                              value={subDivision.subDivisionCode}
                            >
                              {subDivision.subDivisionName}
                            </option>
                          ))}
                        </select>
                      </div>
                    )}

                    {/* Complaint Category */}
                    <div className="field-container">
                      <div
                        style={{
                          display: "flex",
                          marginTop: 20,
                          flexDirection: "column",
                        }}
                      >
                        <Typography className="field-label">
                          Complaint Category
                        </Typography>
                        <FormControl fullWidth error={!!catagoryError}>
                          <Select
                            multiple
                            value={selectedComplaint}
                            onChange={handleChangeCategory}
                            style={{
                              backgroundColor: "white",
                              height: 30,
                              width: 300,
                            }}
                            renderValue={(selected) => {
                              if (selectAllComplaint) {
                                return "All Complaint Categories";
                              }
                              if (selected.length === 0) {
                                return "Select categories";
                              }
                              return selected
                                .map(
                                  (id) =>
                                    complaintList.find((c) => c.Id === id)
                                      ?.Name || id
                                )
                                .filter(Boolean)
                                .join(", ");
                            }}
                            MenuProps={{
                              PaperProps: { style: { width: 400 } },
                            }}
                          >
                            <MenuItem value="all">
                              <Checkbox checked={selectAllComplaint} />
                              <ListItemText primary="All" />
                            </MenuItem>
                            {complaintList.map((item) => (
                              <MenuItem key={item.Id} value={item.Id}>
                                <Checkbox
                                  checked={selectedComplaint.includes(item.Id)}
                                />
                                <ListItemText primary={item.Name} />
                              </MenuItem>
                            ))}
                          </Select>

                          {/* Error Message */}
                          {catagoryError && (
                            <Typography
                              variant="caption"
                              color="error"
                              style={{ marginTop: 4, fontSize: "12px" }}
                            >
                              {catagoryError}
                            </Typography>
                          )}
                        </FormControl>
                      </div>
                    </div>

                    <div className="field-container">
                      <div
                        style={{
                          display: "flex",
                          marginTop: 20,
                          flexDirection: "column",
                        }}
                      >
                        <Typography className="field-label">Source</Typography>
                        <FormControl fullWidth error={!!sourceError}>
                          <Select
                            multiple
                            value={selectedSource}
                            onChange={handleSource}
                            style={{
                              backgroundColor: "white",
                              height: 30,
                              width: 300,
                            }}
                            renderValue={(selected) => {
                              if (selectAllSource) {
                                return "All Sources";
                              }
                              if (selected.length === 0) {
                                return "Select sources";
                              }
                              return selected.join(", ");
                            }}
                            MenuProps={{
                              PaperProps: { style: { width: 400 } },
                            }}
                          >
                            <MenuItem value="all">
                              <Checkbox checked={selectAllSource} />
                              <ListItemText primary="All" />
                            </MenuItem>
                            {sourceList.map((source) => (
                              <MenuItem key={source} value={source}>
                                <Checkbox
                                  checked={selectedSource.includes(source)}
                                />
                                <ListItemText primary={source} />
                              </MenuItem>
                            ))}
                          </Select>
                          {sourceError && (
                            <Typography
                              variant="caption"
                              color="error"
                              style={{ marginTop: 4, fontSize: "12px" }}
                            >
                              {sourceError}
                            </Typography>
                          )}
                        </FormControl>
                      </div>
                    </div>

                      <div style={{ marginTop: "10px" }}>
                        <Button
                          variant="contained"
                          color="primary"
                          onClick={handleGoClick}
                          disabled={isGoDisabled || viewBackdrop}
                        >
                          Go
                        </Button>

                        {/* {errorMessage && (
                                                    <Typography
                                                        color="error"
                                                        variant="body2"
                                                        style={{ marginTop: '8px', fontWeight: 'bold' }}
                                                    >
                                                        {errorMessage}
                                                    </Typography>
                                                )} */}
                      </div>
                  </div>
                </div>
                <div
                  className="table-container"
                  style={{ marginBottom: "40px" }}
                >
                  <div id="pdf-table">
                    <div
                      style={{
                        maxHeight: "900px",
                        overflowY: "auto",
                        overflowX: "hidden",
                      }}
                    >
                      <table
                        className="table"
                        ref={tableRef}
                        style={{
                          marginBottom: "40px",
                          width: "100%",
                          borderCollapse: "collapse",
                        }}
                      >
                        <thead
                          style={{
                            position: "sticky",
                            top: 0,
                            backgroundColor: "white",
                            zIndex: 10,
                          }}
                        >
                          <tr
                            style={{
                              position: "sticky",
                              top: 0,
                              backgroundColor: "white",
                              zIndex: 3,
                            }}
                          >
                            <th
                              colSpan="14"
                              style={{
                                fontSize: "20px",
                                borderBottom: "2px solid white",
                                textAlign: "center",
                                backgroundColor: "#d5e5ff",
                                color: "black",
                              }}
                            >
                              Complaint Report Source and Status Wise for{" "}
                              {officeName} of{" "}
                              {getDateDifference(dateFrom, dateTo) > 0
                                ? formatDate(dateFrom) +
                                  " to " +
                                  formatDate(dateTo)
                                : formatDate(dateFrom)}
                            </th>
                          </tr>
                          <tr
                            style={{
                              position: "sticky",
                              top: "37px",
                              backgroundColor: "white",
                              zIndex: 1,
                            }}
                          >
                            {connectionTypes.map((type, index) => (
                              <th
                                key={index}
                                style={{
                                  width: `${100 / connectionTypes.length}%`,
                                  textAlign: "left",
                                  border: "5px solid white",
                                  backgroundColor: "#eeeff1",
                                  color: "black",
                                  fontSize: "14px",
                                  position: "sticky",
                                  top: 0,
                                  zIndex: 1,
                                }}
                              >
                                {type}
                              </th>
                            ))}
                          </tr>
                        </thead>
                        <tbody>
                          {viewBackdrop ? (
                            <tr>
                              <td
                                colSpan={connectionTypes.length}
                                style={{
                                  textAlign: "center",
                                  padding: "20px",
                                  backgroundColor: "white",
                                }}
                              >
                                <Box
                                  display="flex"
                                  justifyContent="center"
                                  alignItems="center"
                                >
                                  <CircularProgress />
                                </Box>
                              </td>
                            </tr>
                          ) : tableData.length === 0 ? (
                            <tr>
                              <td
                                colSpan="15"
                                style={{
                                  textAlign: "center",
                                  padding: "10px",
                                  fontWeight: "bold",
                                  color: "red",
                                }}
                              >
                                No Data Found
                              </td>
                            </tr>
                          ) : (
                            <>
                              {tableData.map((item, index) => (
                                <tr
                                  key={index}
                                  style={{ borderBottom: "1px solid #ccc" }}
                                >
                                  <td
                                    style={{
                                      backgroundColor: "white",
                                      textAlign: "left",
                                      fontSize: "14px",
                                    }}
                                  >
                                    {item.officeCode}
                                  </td>
                                  {/* <td style={{ backgroundColor: 'white', textAlign: 'left', fontSize: '14px' }}>
                                                                {item.complaintTypeId}
                                                            </td> */}
                                  <td
                                    style={{
                                      backgroundColor: "white",
                                      textAlign: "left",
                                      fontSize: "14px",
                                    }}
                                  >
                                    {complaintList.find(
                                      (complaint) =>
                                        complaint.Id === item.complaintTypeId
                                    )?.Name || item.complaintTypeId}
                                  </td>
                                  <td
                                    style={{
                                      backgroundColor: "white",
                                      textAlign: "left",
                                      fontSize: "14px",
                                    }}
                                  >
                                    {item.totalCount}
                                  </td>
                                </tr>
                              ))}

                              <tr
                                style={{
                                  backgroundColor: "#fff5c0",
                                  fontWeight: "bold",
                                }}
                              >
                                <td
                                  style={{
                                    textAlign: "left",
                                    fontSize: "14px",
                                    fontWeight: "bold",
                                  }}
                                >
                                  Total
                                </td>
                                <td
                                  style={{
                                    textAlign: "left",
                                    fontSize: "14px",
                                    fontWeight: "bold",
                                  }}
                                >
                                  -
                                </td>
                                <td
                                  style={{
                                    textAlign: "left",
                                    fontSize: "14px",
                                    fontWeight: "bold",
                                  }}
                                >
                                  {tableData.reduce(
                                    (sum, item) => sum + (item.totalCount || 0),
                                    0
                                  )}
                                </td>
                              </tr>
                            </>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </Box>
          </div>
        </Box>
        {selectedRemarks && (
          <Popover
            open={open}
            anchorEl={anchorEl}
            onClose={handleClosePopover}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "left",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "left",
            }}
            disableRestoreFocus
          >
            <div style={{ padding: "10px" }}>
              <Typography variant="h6" sx={{ fontSize: "17px" }}>
                Remarks :
              </Typography>
              <Typography sx={{ fontSize: "14px" }}>
                {selectedRemarks}
              </Typography>
            </div>
          </Popover>
        )}
        {/* <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1000 }}
        open={viewBackdrop}
      >
        <CircularProgress color="inherit" />
      </Backdrop> */}
      </>
    )
  );
};

export default ComplaintSourceWise;
